var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{staticStyle:{"text-align":"center"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$store.getters.localization['footer'][_vm.language])}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }